import React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, FormControl, FormHelperText } from "@mui/material";
import dayjs from "dayjs";
import { Field } from "react-final-form";

export const UiDateInput = (props) => {
  const {
    label,
    name,
    error,
    helperText,
    format,
    minDate: minDateProp,
    maxDate: maxDateProp,
    className,
    disabled,
    slotProps: slotPropsProp,
    ...datePickerRest
  } = props;

  return (
    <Field name={name}>
      {({ input, meta }) => {
        const minDate = minDateProp ? dayjs(minDateProp) : undefined;
        const maxDate = maxDateProp ? dayjs(maxDateProp) : undefined;
        const fieldError = error ?? meta.error;
        const showError =
          Boolean(fieldError) && (meta.touched || meta.submitFailed);

        const handleDateChange = (newDate) => {
          if (newDate) {
            const parsedDate = dayjs(newDate);
            if (parsedDate.isValid()) {
              input.onChange(parsedDate.format("YYYY-MM-DD"));
            } else {
              input.onChange(null);
            }
          } else {
            input.onChange(null);
          }
          input.onBlur();
        };

        return (
          <Box className={`df-date-input ${className ? className : ""}`}>
            <FormControl
              sx={{ mb: 2 }}
              variant="outlined"
              fullWidth
              error={showError}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...datePickerRest}
                  className="df-input-field"
                  label={label}
                  value={input.value ? dayjs(input.value, "YYYY-MM-DD") : null}
                  minDate={minDate}
                  maxDate={maxDate}
                  onChange={handleDateChange}
                  format={format}
                  disabled={disabled ? disabled : false}
                  slotProps={{
                    ...slotPropsProp,
                    textField: {
                      ...slotPropsProp?.textField,
                      error: showError,
                    },
                  }}
                />
              </LocalizationProvider>

              {showError && (
                <FormHelperText className="component-error-text">
                  {fieldError}
                </FormHelperText>
              )}

              {helperText && !showError && (
                <FormHelperText className="df-helper-text">
                  {helperText}
                </FormHelperText>
              )}
            </FormControl>
          </Box>
        );
      }}
    </Field>
  );
};
